import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw24px = 'M11.485 6.1V18H10.04v-5.559H4.345V18H2.9V6.1h1.445v5.134h5.695V6.1h1.445Zm6.905 4.454c2.38 0 3.79 1.428 3.79 3.162v1.139c0 1.887-1.717 3.349-4.114 3.349-2.04 0-3.128-.799-4.063-1.921l.918-.782c.833.918 1.65 1.513 3.128 1.513 1.496 0 2.686-.765 2.686-2.244v-.901c0-1.394-1.156-2.142-2.805-2.142-.714 0-1.19.102-1.853.323H15.04V6.1h6.511v1.241h-5.083v3.502c.527-.187 1.071-.289 1.921-.289Z';
const icons = {
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const TextH5Icon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'textH5'));
TextH5Icon.displayName = 'TextH5Icon';
TextH5Icon.propTypes = Icon.propTypes;
TextH5Icon.renderIcon = props => /*#__PURE__*/React.createElement(TextH5Icon, props);
export default TextH5Icon;
//# sourceMappingURL=TextH5Icon.js.map